import { z } from 'zod';

import { dateOnlySchema, isoDateTimeSchema, uuidSchema } from './common.js';

const hoursSchema = z.coerce.number().min(0).max(9999);
const timeOfDaySchema = z
  .string()
  .regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Время должно быть в формате HH:MM');

export const pileEntrySchema = z.object({
  id: uuidSchema,
  date: dateOnlySchema,
  time: timeOfDaySchema.nullable(),
  description: z.string().min(1).max(500),
  hours: hoursSchema,
  ownerId: uuidSchema.nullable(),
  createdAt: isoDateTimeSchema,
  updatedAt: isoDateTimeSchema,
});
export type PileEntryDto = z.infer<typeof pileEntrySchema>;

export const createPileEntrySchema = z.object({
  date: dateOnlySchema,
  time: timeOfDaySchema.nullable().optional(),
  description: z.string().min(1, 'Введите описание').max(500),
  hours: hoursSchema.default(0),
  ownerId: uuidSchema.nullable().optional(),
});
export type CreatePileEntryDto = z.infer<typeof createPileEntrySchema>;

export const updatePileEntrySchema = createPileEntrySchema.partial();
export type UpdatePileEntryDto = z.infer<typeof updatePileEntrySchema>;

export const sendPileToProjectSchema = z.object({
  entryIds: z.array(uuidSchema).min(1, 'Выберите хотя бы одну запись'),
  projectId: uuidSchema,
});
export type SendPileToProjectDto = z.infer<typeof sendPileToProjectSchema>;
